var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7071 0.29289C8.3166 -0.09763 7.6834 -0.09763 7.2929 0.29289L0.292902 7.2929C-0.0975971 7.6834 -0.0975971 8.3166 0.292902 8.7071L7.2929 15.7071C7.6834 16.0976 8.3166 16.0976 8.7071 15.7071C9.0976 15.3166 9.0976 14.6834 8.7071 14.2929L3.4142 9H17C17.5523 9 18 8.5523 18 8C18 7.4477 17.5523 7 17 7H3.4142L8.7071 1.70711C9.0976 1.31658 9.0976 0.68342 8.7071 0.29289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.45d2adcdc548e50a22c098441e5ec65e.svg";
export { ForwardRef as ReactComponent };